import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { News } from "./Menu";
import DropDown from "./DropDown";

export default function Header({ variant }) {
    const [isSticky, setIsSticky] = useState(false);
    const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
    const [mobileToggle, setMobileToggle] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
        });
    }, []);

    return (
        <>
        <div className={`header__area ${ variant ? variant : "" } header__sticky ${isSticky ? "header__sticky-active" : ""}`}>
            <div className="container custom-container">
                <div className="header__area-box">
                    <div className="header__area-box-logo">
                        <Link to='/'><img src="assets/img/logo-1.png" alt="" /></Link>
                    </div>
                    <div className="header__area-box-main-menu one">
                        <ul className="mobile__menu" style={{ display: `${mobileToggle ? "block" : "none"}` }}>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/tournaments">Tournaments</Link></li>
                            <li className="menu-item-has-children">
                                <Link to="">Rating</Link>
                                <DropDown>
                                    <ul className="sub-menu">
                                    <News />                       
                                    </ul>
                                </DropDown>
                            </li>
                            <li><Link to="/news">News</Link></li>
                            <li><Link to="/scam">Scam list</Link></li>
                        </ul>
                        <span className={mobileToggle ? "mobile-menu mobile-menu-active" : "mobile-menu"} onClick={() => setMobileToggle(!mobileToggle)}>
                            <span></span>
                        </span>
                    </div>
                    <div className="header__area-box-sidebar">
                        <div className="header__area-box-sidebar-popup-icon"> 
                            <span onClick={() => setSideHeaderToggle(!sideHeaderToggle)}><i className="fal fa-bars"></i></span> 
                        </div>
                    </div>
                    <div className={sideHeaderToggle ? 'header__area-box-sidebar-popup active' : 'header__area-box-sidebar-popup'}>
                        <div className="sidebar-close-btn one" onClick={() => setSideHeaderToggle(!sideHeaderToggle)}> <i className="fal fa-times"></i> </div>
                        <div className="header__area-box-sidebar-popup-logo">
                            <Link to='/'><img src="assets/img/logo-1.png" alt="" /></Link>
                        </div>
                        <p>TMESPORTS is your reliable source of information about mobile esports, specializing in PUBG Mobile. Find out the latest news, ratings, and participate in exciting tournaments. Join the community of players and become a part of the dynamic world of mobile esports!</p>
                        <div className="header__area-box-sidebar-popup-contact">
                            <h4 className="mb-25">Contact Us</h4>
                            <div className="header__area-box-sidebar-popup-follow-us-social">
                                <ul>
                                    <li><a style={{display: 'flex', alignItems: 'center', gap: '8px'}} target="_blank" href="https://t.me/neYourArchangel"><i className="fab fa-telegram"></i> - @admin </a></li>
                                </ul>
                            </div>  
                        </div>
                        <div className="header__area-box-sidebar-popup-follow-us">
                            <h4 className="mb-25">Follow Us</h4>
                            <div className="header__area-box-sidebar-popup-follow-us-social">
                                <ul>
                                    <li><a target="_blank" href="https://t.me/tmt_org"><i className="fab fa-telegram"></i></a> </li>
                                    <li><a target="_blank" href="https://discord.gg/UCCjYYWz33"><i className="fab fa-discord"></i></a> </li>
                                    <li><a target="_blank" href="https://www.instagram.com/tmt_org"><i className="fab fa-instagram"></i></a> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={sideHeaderToggle ? 'sidebar-overlay show' : 'sidebar-overlay'}></div> 
                </div>
            </div>
        </div>
        </>
    );
}
